import { combineReducers } from 'redux';
import EventReducer from '../../core/events/reducer';
import NotificationReducer from '../../core/notifications/reducer';
import RatingReducer from '../../core/ratings/reducer';
import UserReducer from '../../core/users/reducer';
import VenueReducer from '../../core/venues/reducer';
import VendorEvents from '../../core/vendor-events/reducer';
import chatReducer from '../../core/chat/reducer';
import categoryReducer from '../../core/categories/reducer';
import BalanceReducer from '../../core/balance/reducer';
import SystemParamters from '../../core/system-parameters/reducer';
import locationReducer from '../../core/location/reducer';
import homeReducer from '../../core/home/reducer';
import vendorEventsPaginatedReducer from '../../pages/app/venue-applications/redux/vendorEventsReducer';
import RetailProfilesReducer from '../../core/retail-profiles/reducer';
import VendorRetailReducer from '../../core/vendor-retail/reducer';

const rootReducer = combineReducers({
  events: EventReducer,
  vendorEvents: VendorEvents,
  users: UserReducer,
  venues: VenueReducer,
  ratings: RatingReducer,
  notifications: NotificationReducer,
  chat: chatReducer,
  categories: categoryReducer,
  balance: BalanceReducer,
  systemParameters: SystemParamters,
  location: locationReducer,
  home: homeReducer,
  vendorEventsPaginated: vendorEventsPaginatedReducer,
  retailProfiles: RetailProfilesReducer,
  vendorRetail: VendorRetailReducer,
});

export default rootReducer;
